/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentStepDto } from './DeploymentStepDto';
import {
    DeploymentStepDtoFromJSON,
    DeploymentStepDtoFromJSONTyped,
    DeploymentStepDtoToJSON,
} from './DeploymentStepDto';

/**
 * 
 * @export
 * @interface DeploymentStepsDto
 */
export interface DeploymentStepsDto {
    /**
     * The steps of the most recent deployment update.
     * @type {Array<DeploymentStepDto>}
     * @memberof DeploymentStepsDto
     */
    steps: Array<DeploymentStepDto>;
}

/**
 * Check if a given object implements the DeploymentStepsDto interface.
 */
export function instanceOfDeploymentStepsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "steps" in value;

    return isInstance;
}

export function DeploymentStepsDtoFromJSON(json: any): DeploymentStepsDto {
    return DeploymentStepsDtoFromJSONTyped(json, false);
}

export function DeploymentStepsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentStepsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'steps': ((json['steps'] as Array<any>).map(DeploymentStepDtoFromJSON)),
    };
}

export function DeploymentStepsDtoToJSON(value?: DeploymentStepsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'steps': ((value.steps as Array<any>).map(DeploymentStepDtoToJSON)),
    };
}

